export const LOGIN = 'login';
export const LOGOUT = 'logout';

export const SET_ROLE = 'set_role';

export const SET_MENU_PERMISSIONS = 'set_menu_permissions';

export const SET_OPERATOR = 'set_operator';

export const ADD_CACHED_COMPONENTS = 'add_cached_components';
export const DEL_CACHED_COMPONENTS = 'del_cached_components';



// WEBPACK FOOTER //
// ./src/store/types.js